import React from 'react';
import { Star, Clock, Percent, Gift, ArrowRight, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { useLanguage } from '../contexts/LanguageContext';

const PromotionsPage = () => {
  const { language } = useLanguage();

  const translations = {
    en: {
      title: 'Special Offers',
      subtitle: 'Exclusive promotions and packages for our valued clients',
      validUntil: 'Valid until',
      bookNow: 'Book Now',
      learnMore: 'Learn More',
      limitedOffer: 'Limited Offer',
      newClient: 'New Client Special',
      package: 'Package Deal',
      seasonal: 'Seasonal Offer'
    },
    fr: {
      title: 'Offres Spéciales',
      subtitle: 'Promotions et forfaits exclusifs pour nos clients fidèles',
      validUntil: 'Valable jusqu\'au',
      bookNow: 'Réserver',
      learnMore: 'En savoir plus',
      limitedOffer: 'Offre Limitée',
      newClient: 'Spécial Nouveau Client',
      package: 'Forfait',
      seasonal: 'Offre Saisonnière'
    },
    pt: {
      title: 'Ofertas Especiais',
      subtitle: 'Promoções e pacotes exclusivos para os nossos clientes',
      validUntil: 'Válido até',
      bookNow: 'Reservar',
      learnMore: 'Saber mais',
      limitedOffer: 'Oferta Limitada',
      newClient: 'Especial Novo Cliente',
      package: 'Pacote',
      seasonal: 'Oferta Sazonal'
    }
  };

  const t = translations[language] || translations.en;

  const promotions = [
    {
      id: 'promo1',
      badge: t.package,
      title_en: 'Boobs Treatment - Restructure Package',
      title_fr: 'Traitement Poitrine - Forfait Restructuration',
      title_pt: 'Tratamento Seios - Pacote Reestruturação',
      description_en: 'With a view to Restructure your Breasts, this Treatment combines Toning and Modeling techniques of wood therapy with Special Push Up Cosmetics, Potentiated by Vacuum therapy to Galvanize your Curves to regain the Graceful harmony so Desired.',
      description_fr: 'En vue de Restructurer votre Poitrine, ce Traitement combine des techniques de Tonification et de Modelage de la wood thérapie avec des Cosmétiques Spéciaux Push Up, Potentialisés par la Vacuum thérapie pour Galvaniser vos Courbes et retrouver l\'harmonie Gracieuse tant Désirée.',
      description_pt: 'Com vista a Reestruturar os seus Seios, este Tratamento combina técnicas de Tonificação e Modelagem da wood therapy com Cosméticos Especiais Push Up, Potenciados pela Vacuum therapy para Galvanizar as suas Curvas e recuperar a harmonia Graciosa tão Desejada.',
      duration: '60min/session',
      originalPrice: '190€',
      promoPrice: '48€/session',
      savings: 'Pack of 4 sessions',
      image: 'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=600',
      color: 'from-pink-500 to-rose-600',
      validUntil: '2026-03-31'
    },
    {
      id: 'promo2',
      badge: t.newClient,
      title_en: 'First Visit Special - 20% OFF',
      title_fr: 'Spécial Première Visite - 20% DE RÉDUCTION',
      title_pt: 'Especial Primeira Visita - 20% DE DESCONTO',
      description_en: 'Welcome to IPRBC KAMIT! Enjoy 20% off on any service on your first visit. Valid for massages, spa treatments, and beauty services.',
      description_fr: 'Bienvenue chez IPRBC KAMIT! Profitez de 20% de réduction sur tout service lors de votre première visite. Valable pour massages, soins spa et services beauté.',
      description_pt: 'Bem-vindo ao IPRBC KAMIT! Aproveite 20% de desconto em qualquer serviço na sua primeira visita. Válido para massagens, tratamentos de spa e serviços de beleza.',
      duration: 'Any service',
      originalPrice: '',
      promoPrice: '-20%',
      savings: 'First visit only',
      image: 'https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=600',
      color: 'from-kamit-gold to-amber-600',
      validUntil: '2026-12-31'
    },
    {
      id: 'promo3',
      badge: t.package,
      title_en: 'Relaxation Duo - Massage + Facial',
      title_fr: 'Duo Relaxation - Massage + Soin Visage',
      title_pt: 'Duo Relaxamento - Massagem + Facial',
      description_en: 'Combine our signature relaxation massage with a rejuvenating facial treatment for the ultimate pampering experience.',
      description_fr: 'Combinez notre massage relaxant signature avec un soin du visage rajeunissant pour une expérience de bien-être ultime.',
      description_pt: 'Combine a nossa massagem de relaxamento com um tratamento facial rejuvenescedor para a experiência definitiva de bem-estar.',
      duration: '90min',
      originalPrice: '130€',
      promoPrice: '99€',
      savings: 'Save 31€',
      image: 'https://images.unsplash.com/photo-1540555700478-4be289fbec6f?w=600',
      color: 'from-teal-500 to-emerald-600',
      validUntil: '2026-02-28'
    },
    {
      id: 'promo4',
      badge: t.seasonal,
      title_en: 'Winter Skin Care Package',
      title_fr: 'Forfait Soins d\'Hiver',
      title_pt: 'Pacote Cuidados de Inverno',
      description_en: 'Hydrating body treatment + moisturizing facial to combat dry winter skin. Includes take-home skincare samples.',
      description_fr: 'Traitement corporel hydratant + soin visage hydratant pour combattre la peau sèche d\'hiver. Inclut des échantillons de soins à emporter.',
      description_pt: 'Tratamento corporal hidratante + facial hidratante para combater a pele seca de inverno. Inclui amostras de cuidados para levar.',
      duration: '75min',
      originalPrice: '110€',
      promoPrice: '85€',
      savings: 'Save 25€',
      image: 'https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=600',
      color: 'from-blue-500 to-indigo-600',
      validUntil: '2026-02-28'
    },
    {
      id: 'promo5',
      badge: t.limitedOffer,
      title_en: 'Lash Extensions - Full Set',
      title_fr: 'Extensions de Cils - Pose Complète',
      title_pt: 'Extensões de Pestanas - Pose Completa',
      description_en: 'Get stunning lash extensions with 15% off your first full set. Natural, doll, or cat effect available.',
      description_fr: 'Obtenez de superbes extensions de cils avec 15% de réduction sur votre première pose complète. Effet naturel, poupée ou chat disponible.',
      description_pt: 'Obtenha extensões de pestanas deslumbrantes com 15% de desconto na sua primeira pose completa. Efeito natural, boneca ou gato disponível.',
      duration: '90-120min',
      originalPrice: '65€',
      promoPrice: '55€',
      savings: 'Save 10€',
      image: 'https://images.unsplash.com/photo-1583001931096-959e9a1a6223?w=600',
      color: 'from-purple-500 to-violet-600',
      validUntil: '2026-02-15'
    },
    {
      id: 'promo6',
      badge: t.package,
      title_en: 'Mani-Pedi Combo',
      title_fr: 'Combo Mani-Pédi',
      title_pt: 'Combo Mani-Pedi',
      description_en: 'Classic manicure + soft pedicure combo at a special price. The perfect nail care package.',
      description_fr: 'Combo manucure classique + pédicure douce à un prix spécial. Le forfait soins des ongles parfait.',
      description_pt: 'Combo manicure clássica + pedicure suave a um preço especial. O pacote perfeito de cuidados de unhas.',
      duration: '80min',
      originalPrice: '75€',
      promoPrice: '60€',
      savings: 'Save 15€',
      image: 'https://images.unsplash.com/photo-1604654894610-df63bc536371?w=600',
      color: 'from-rose-400 to-pink-600',
      validUntil: '2026-03-15'
    }
  ];

  const getTitle = (promo) => promo[`title_${language}`] || promo.title_en;
  const getDescription = (promo) => promo[`description_${language}`] || promo.description_en;

  return (
    <div className="min-h-screen bg-kamit-beige pt-24 pb-16" data-testid="promotions-page">
      {/* Hero Section */}
      <div className="bg-gradient-to-br from-kamit-brown via-kamit-brown/90 to-kamit-gold/80 py-16 mb-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="flex items-center justify-center gap-2 mb-4">
            <Sparkles className="h-8 w-8 text-kamit-gold" />
            <h1 className="font-heading text-4xl md:text-5xl text-kamit-beige">{t.title}</h1>
            <Sparkles className="h-8 w-8 text-kamit-gold" />
          </div>
          <p className="text-kamit-beige/80 text-lg max-w-2xl mx-auto">{t.subtitle}</p>
          <div className="w-24 h-1 bg-kamit-gold mx-auto mt-6" />
        </div>
      </div>

      {/* Promotions Grid */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {promotions.map((promo) => (
            <div
              key={promo.id}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all group"
              data-testid={`promo-card-${promo.id}`}
            >
              {/* Image */}
              <div className="relative h-48 overflow-hidden">
                <img
                  src={promo.image}
                  alt={getTitle(promo)}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className={`absolute inset-0 bg-gradient-to-t ${promo.color} opacity-60`} />
                <div className="absolute top-4 left-4">
                  <span className="bg-white/90 text-kamit-brown px-3 py-1 rounded-full text-xs font-semibold flex items-center gap-1">
                    <Percent className="h-3 w-3" />
                    {promo.badge}
                  </span>
                </div>
                <div className="absolute bottom-4 right-4">
                  <span className="bg-kamit-gold text-white px-4 py-2 rounded-full text-lg font-bold">
                    {promo.promoPrice}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="font-heading text-xl text-kamit-brown mb-2">{getTitle(promo)}</h3>
                <p className="text-kamit-brown/70 text-sm mb-4 line-clamp-3">{getDescription(promo)}</p>

                <div className="flex flex-wrap gap-2 mb-4">
                  <span className="flex items-center gap-1 text-xs bg-kamit-beige text-kamit-brown px-2 py-1 rounded-full">
                    <Clock className="h-3 w-3" />
                    {promo.duration}
                  </span>
                  {promo.originalPrice && (
                    <span className="text-xs text-kamit-brown/50 line-through px-2 py-1">
                      {promo.originalPrice}
                    </span>
                  )}
                  <span className="flex items-center gap-1 text-xs bg-green-100 text-green-700 px-2 py-1 rounded-full">
                    <Gift className="h-3 w-3" />
                    {promo.savings}
                  </span>
                </div>

                <div className="flex items-center justify-between pt-4 border-t border-kamit-brown/10">
                  <span className="text-xs text-kamit-brown/50">
                    {t.validUntil}: {new Date(promo.validUntil).toLocaleDateString()}
                  </span>
                  <Link to="/contact">
                    <Button size="sm" className="bg-kamit-gold hover:bg-kamit-gold/90 text-white rounded-full">
                      {t.bookNow}
                      <ArrowRight className="ml-1 h-4 w-4" />
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="mt-16 text-center bg-kamit-brown rounded-2xl p-8 md:p-12">
          <Star className="h-12 w-12 text-kamit-gold mx-auto mb-4" />
          <h2 className="font-heading text-2xl md:text-3xl text-kamit-beige mb-4">
            {language === 'fr' ? 'Vous avez des questions sur nos offres?' : 'Have questions about our offers?'}
          </h2>
          <p className="text-kamit-beige/80 mb-6 max-w-xl mx-auto">
            {language === 'fr' 
              ? 'Contactez-nous pour plus d\'informations ou pour réserver votre rendez-vous dès maintenant.'
              : 'Contact us for more information or to book your appointment now.'}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact">
              <Button className="bg-kamit-gold hover:bg-kamit-gold/90 text-white rounded-full px-8">
                {language === 'fr' ? 'Nous Contacter' : 'Contact Us'}
              </Button>
            </Link>
            <a href="mailto:iprbckamit@gmail.com">
              <Button variant="outline" className="border-kamit-beige text-kamit-beige hover:bg-kamit-beige/10 rounded-full px-8">
                iprbckamit@gmail.com
              </Button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromotionsPage;
